(() => {
  if (window.dmrFaqInitialized) return;
  window.dmrFaqInitialized = true;
  const normalize = value => String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const setup = root => {
    if (root.dataset.dmrReady) return;
    root.dataset.dmrReady = 'true';
    const query = root.querySelector('[data-dmr-faq-query]');
    const results = root.querySelector('[data-dmr-faq-results]');
    const empty = root.querySelector('[data-dmr-faq-empty]');
    const topics = [...root.querySelectorAll('[data-dmr-faq-topic]')];
    const items = [...root.querySelectorAll('[data-dmr-faq-item]')];
    const links = [...root.querySelectorAll('[data-dmr-faq-topic-link]')];
    const total = items.length;
    const filter = () => {
      const needle = normalize(query.value.trim());
      let shown = 0;
      items.forEach(item => {
        const match = !needle || normalize(item.textContent).includes(needle);
        item.hidden = !match;
        if (match) shown++;
        if (needle && match) item.open = true;
        if (!needle) item.open = false;
      });
      topics.forEach(topic => { topic.hidden = ![...topic.querySelectorAll('[data-dmr-faq-item]')].some(item => !item.hidden); });
      links.forEach(link => { const topic = root.querySelector('#' + link.dataset.dmrFaqTopicLink); link.hidden = !!topic && topic.hidden; });
      if (empty) empty.hidden = shown > 0;
      if (results) results.textContent = needle ? (shown ? shown + (shown > 1 ? ' réponses' : ' réponse') : '') : total + ' réponses';
    };
    if (query) { query.addEventListener('input', filter); filter(); }
    links.forEach(link => link.addEventListener('click', event => {
      const topic = root.querySelector('#' + link.dataset.dmrFaqTopicLink);
      if (!topic) return;
      event.preventDefault();
      topic.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + link.dataset.dmrFaqTopicLink);
    }));
    if ('IntersectionObserver' in window && topics.length) {
      const current = new Map();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => current.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
        const best = topics.filter(t => !t.hidden).map(t => [t, current.get(t) || 0]).sort((a, b) => b[1] - a[1])[0];
        links.forEach(link => link.setAttribute('aria-current', String(!!best && best[1] > 0 && link.dataset.dmrFaqTopicLink === best[0].id)));
      }, { threshold: [0, .2, .4, .6, .8, 1], rootMargin: '-10% 0px -60% 0px' });
      topics.forEach(t => observer.observe(t));
    }
    if (location.hash) {
      const target = root.querySelector(location.hash);
      if (target) setTimeout(() => target.scrollIntoView({ block: 'start' }), 50);
    }
  };
  const initialise = () => document.querySelectorAll('[data-dmr-faq]').forEach(setup);
  document.addEventListener('shopify:section:load', initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true }); else initialise();
})();
